import { Component, OnInit, ViewChild } from '@angular/core';
import { NouisliderComponent } from 'ng2-nouislider';
import { FilingsService } from '../../filings.service';

@Component({
  selector: 'app-slider-total-value',
  templateUrl: './slider-total-value.component.html',
  styleUrls: ['./slider-total-value.component.scss']
})
export class SliderTotalValueComponent {
  @ViewChild('slider') slider: NouisliderComponent;
  config: any = {
    behaviour: 'drag',
    connect: true,
    snap: true,
    range: {
      min: 10000,
      '25%': 100000,
      '50%': 500000,
      '75%': 1000000,
      max: 10000000
    },
  };
  modelRange = [0]; // 1000000 means 100+
  minAmount = '10K';

  constructor(private filingsService: FilingsService) { }

  onChange(e?) {
    let result: string;
    switch (e) {
      case 10000:
        result = '10K';
        break;
      case 100000:
        result = '100K';
        break;
      case 500000:
        result = '500K';
        break;
      case 1000000:
        result = '1M';
        break;
      case 10000000:
        result = '10M';
        break;
    }
    this.minAmount = result;
    this.filingsService.onTotalValueSliderChanged(e);
  }
}
